import { render, staticRenderFns } from "./appleBrand.vue?vue&type=template&id=6c6ee827&"
import script from "./appleBrand.vue?vue&type=script&lang=js&"
export * from "./appleBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports